import React, { useEffect, useRef } from "react";
const OutsideClickHandler = ({
  children,
  onClickOutside,
  requiredFLex = true,
  isInLineFlex = false,
}) => {
  const wrapperRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClickOutside(event);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClickOutside]);
  return (
    <>
      <div style={requiredFLex ? { display: isInLineFlex ? "inline-flex" : "flex" } : ""} ref={wrapperRef}>
        {children}
      </div>
    </>
  );
};
export default OutsideClickHandler;
